import React from "react";
import { Button } from "../ui/button";
import { ArrowRight, Instagram, Facebook, Send } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { WHATSAPP_URL } from "../../config";

export default function Footer() {
  const { t } = useLang();
  const openClaim = () => window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");

  return (
    <footer id="fineprint" className="bg-[var(--aa-wine-deep)] text-[var(--aa-cream)]">
      <div className="mx-auto max-w-6xl px-6 md:px-8 pt-20 md:pt-28 pb-16">
        <div className="rounded-[32px] bg-[var(--aa-cream)] text-[var(--aa-ink)] p-10 md:p-16 relative overflow-hidden">
          <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-[var(--aa-wine)]/10"></div>
          <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-[var(--aa-wine)]/5"></div>
          <div className="relative max-w-2xl">
            <div className="text-[11px] tracking-[0.24em] uppercase text-[var(--aa-wine)] font-semibold mb-4">
              {t.footerCTA.eyebrow}
            </div>
            <h3 className="font-display font-light text-4xl md:text-6xl leading-[1.02] text-[var(--aa-ink)]">
              {t.footerCTA.h3a}
              <br /> <span className="italic">{t.footerCTA.h3b}</span>
            </h3>
            <p className="mt-6 text-[15px] md:text-lg text-[var(--aa-ink-soft)]">
              {t.footerCTA.p}
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Button
                onClick={openClaim}
                className="rounded-full bg-[var(--aa-wine)] hover:bg-[var(--aa-wine-deep)] text-[var(--aa-cream)] px-7 py-6 font-semibold group"
              >
                {t.footerCTA.claimBtn}
                <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
              </Button>
              <a href="#" className="text-[14px] font-medium text-[var(--aa-wine)] underline underline-offset-4" hidden>
                {t.footerCTA.salesLink}
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-6 md:px-8 py-14 grid md:grid-cols-4 gap-10 border-t border-white/10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <img
              src="https://www.andabout.com/assets/branding/a.svg"
              alt=""
              aria-hidden="true"
              className="h-8 w-8"
              style={{ filter: "brightness(0) invert(1)" }}
            />
            <img
              src="https://www.andabout.com/assets/branding/andabout.svg"
              alt="andabout"
              className="h-5 w-auto"
              style={{ filter: "brightness(0) invert(1)" }}
            />
          </div>
          <p className="mt-4 text-[13.5px] text-[var(--aa-cream)]/70 max-w-md leading-relaxed">
            {t.footer.about}
          </p>
          <div className="flex gap-3 mt-6">
            {[Instagram, Facebook, Send].map((I, i) => (
              <a
                key={i}
                href="#"
                className="inline-flex w-9 h-9 items-center justify-center rounded-full border border-white/15 hover:bg-white/10 transition-colors"
              >
                <I className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--aa-cream)]/60 mb-4">{t.footer.forBusiness}</div>
          <ul className="space-y-2 text-[13.5px]">
            {t.footer.forBusinessLinks.map((l, i) => (
              <li key={i}><a href="#" className="hover:text-[var(--aa-cream)] text-[var(--aa-cream)]/80">{l}</a></li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--aa-cream)]/60 mb-4">{t.footer.company}</div>
          <ul className="space-y-2 text-[13.5px]">
            {t.footer.companyLinks.map((l, i) => (
              <li key={i}><a href="#" className="hover:text-[var(--aa-cream)] text-[var(--aa-cream)]/80">{l}</a></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-6xl px-6 md:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[11.5px] text-[var(--aa-cream)]/60">
          <div>{t.footer.copyright}</div>
          <div className="max-w-3xl leading-relaxed">{t.footer.finePrint}</div>
        </div>
      </div>
    </footer>
  );
}
